// extracted by mini-css-extract-plugin
export default {"message":"LoaderWidget_message__ybc10"};